<div>
  <div class="image-container shimmer" />
  <div class="content shimmer" />
</div>

<style>
  .image-container {
    aspect-ratio: 2/1;
    border-radius: 16px;
  }

  .content {
    height: 20px;
    margin: 14px 0;
  }
</style>
